
export class BaseDataResult {
    private ok: boolean;
    private statusCode: number;
    private statusText: string;

    constructor(ok: boolean, status: number, statusText: string) {
        this.ok = ok;
        this.statusCode = status;
        this.statusText = statusText;
    }

    get Ok(): boolean { return this.ok; }

    get Status(): number { return this.statusCode; }
    set Status(value: number) { this.statusCode = value; }

    get StatusText(): string { return this.statusText; }
    set StatusText(value: string) { this.statusText = value; }
}
